<template>
  <div class="nx-signing-modal-method">
    <h4>Define the field for signing</h4>

    <h5 class="mt-4">Please fill in the following form for the field</h5>

    <b-container class="text-left mt-4">
      <b-row align-h="center">
        <b-col sm="8">
          <b-form @submit.prevent="submit">
            <b-form-group label="Name">
              <b-form-input name="name" v-model="form.name" />
            </b-form-group>
            <b-form-group label="Page number">
              <b-form-input name="pageNumber" v-model="form.pageNumber" />
            </b-form-group>
            <b-form-group label="Left">
              <b-form-input name="left" v-model="form.left" />
            </b-form-group>
            <b-form-group label="Bottom">
              <b-form-input name="bottom" v-model="form.bottom" />
            </b-form-group>
            <b-form-group label="Right">
              <b-form-input name="right" v-model="form.right" />
            </b-form-group>
            <b-form-group label="Top">
              <b-form-input name="top" v-model="form.top" />
            </b-form-group>

            <b-button type="submit" class="float-right">Submit</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  props: {
    value: {},
  },
  data() {
    return {
      form: {
        name: "Sig",
        pageNumber: 1,
        left: 20,
        bottom: 20,
        right: 100,
        top: 100,
      },
    };
  },
  methods: {
    submit() {
      this.$emit("input", {
        ...this.value,
        field: cloneDeep(this.form),
      });
      this.$emit("next");
    },
  },
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-method {
  text-align: center;
}
</style>
